import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const rejectReturn = {
  name: "rejectReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    customerRecoveryAmount: z.number(),
    handOffToMerchant: z.boolean(),
    sendNotification: z.boolean(),
    customerNotes: z.string().optional(),
    customerImages: z.array(z.string()).optional(),
  }),
  output: z.null(),
};
